import { type Country } from "@/domain/country";

import { loadBraintreePayPalMessages } from "./braintree";

export interface EnsurePayPalSdkInput {
	endpoint: string;
	country: Country;
	currency: "USD" | "CAD";
}

// Load the SDK at most once per page; clear on failure so a later mount can retry.
let initPromise: Promise<void> | null = null;

export function ensurePayPalMessagesSdk(
	input: EnsurePayPalSdkInput
): Promise<void> {
	if (initPromise) {
		return initPromise;
	}
	initPromise = loadBraintreePayPalMessages(input).catch((err) => {
		initPromise = null;
		throw err;
	});
	return initPromise;
}
